import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

// RTL languages among those we ship. Note: Persian is shipped as `fa-latn-ir`
// (Latin script), which is LTR, so it is intentionally excluded.
const RTL_LANGUAGES = ['ar', 'ps'] // Arabic and Pashto (Arabic-script) are RTL

export function useRtl() {
  const { i18n } = useTranslation()

  useEffect(() => {
    const isRtl = RTL_LANGUAGES.some((lang) => i18n.language.startsWith(lang))
    const direction = isRtl ? 'rtl' : 'ltr'
    const htmlElement = document.documentElement

    // Set the dir attribute on the html element
    htmlElement.setAttribute('dir', direction)

    // Update the lang attribute to match the current language
    htmlElement.setAttribute('lang', i18n.language)
  }, [i18n.language])
}
